import { Component, EventEmitter, OnInit, Output, inject, viewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Counter, Delay, Filter, Parallel, Reward, Sequential } from 'src/app/api/api-campaigns.service.generated';
import { SnackbarService } from 'src/app/common/services/snackbar-service';
import { ActionContext, ActionOperation } from '../step-action.service';
import { StrategyName } from '../strategies/strategy/strategy.component';

import { FormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { StrategyEditComponent } from '../strategies-edit/strategy-edit/strategy-edit.component';
import { ButtonComponent } from "wecheer-common";
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-strategy-edit-panel',
  templateUrl: './strategy-edit-panel.component.html',
  styleUrls: ['./strategy-edit-panel.component.scss'],
  imports: [
    FormsModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    StrategyEditComponent,
    ButtonComponent
]
})
export class StrategyEditPanelComponent implements OnInit {
  private snackbar = inject(SnackbarService);


  readonly drawer = viewChild<MatDrawer>('drawer');

  ctx: ActionContext;
  strategy: any;        // edited


  @Output() strategySaved = new EventEmitter<ActionContext>();

  ActionOperation = ActionOperation;
  StrategyName = StrategyName;
  strategyNames = [StrategyName.Filter, StrategyName.Parallel, StrategyName.Sequential, StrategyName.Reward, StrategyName.Counter, StrategyName.Delay];

  errors: string[];

  ngOnInit() {
  }

  onStrategyChanged(strategyName: StrategyName) {
    const strategyMap = {
      [StrategyName.Filter]: () => new Filter({ name: StrategyName.Filter, consumptionFilters: [] }),
      [StrategyName.Reward]: () => new Reward({ name: StrategyName.Reward }),
      [StrategyName.Parallel]: () => new Parallel({ name: StrategyName.Parallel }),
      [StrategyName.Sequential]: () => new Sequential({ name: StrategyName.Sequential }),
      [StrategyName.Delay]: () => new Delay({ name: StrategyName.Delay, duration: '00:00:00', startTime: undefined, endTime: undefined }),
      [StrategyName.Counter]: () => new Counter({ name: StrategyName.Counter })
    };

    if (strategyMap[strategyName]) {
      this.strategy = strategyMap[strategyName]();
    }
  }

  async onSave() {
    this.errors = this.getValidationErrors();
    if (this.errors.length > 0) return;

    this.drawer().close();

    this.ctx.edited = this.strategy;
    this.strategySaved.emit(this.ctx);
    this.snackbar.open('Step saved', null, 3000);
  }

  getValidationErrors(): string[] {
    let errors = [];
    if (this.strategy.name == StrategyName.Filter) {
      const f = this.strategy as Filter;
      if (!f.title) errors.push('Please enter the strategy name');
      if (!f.consumptionFilters || f.consumptionFilters.length == 0) errors.push('Please add at least 1 consumption filter');
    }

    if (this.strategy.name == StrategyName.Parallel) {
      const f = this.strategy as Parallel;
      if (!f.title) errors.push('Please enter the strategy name');
    }

    if (this.strategy.name == StrategyName.Sequential) {
      const f = this.strategy as Sequential;
      if (!f.name) errors.push('Please enter the strategy name');
    }

    if (this.strategy.name == StrategyName.Counter) {
      const f = this.strategy as Counter;
      if (!f.title) errors.push('Please enter the strategy name');
      if (!f.maxStampCount) errors.push('Please select stamp count');
    }

    if (this.strategy.name == StrategyName.Reward) {
      const f = this.strategy as Reward;
      if (!f.title) errors.push('Please enter the strategy name');
      if (!f.coinReward && !f.productReward) errors.push('Please select a reward');
    }

    if (this.strategy.name == StrategyName.Delay) {
      const f = this.strategy as Delay;
      if (!f.title) errors.push('Please enter the strategy name');
      if (!this.isValidDuration(f.duration)) errors.push('Please enter a valid duration');
    }

    return errors;
  }

  onCancel() {
    this.drawer().close();
  }

  open(ctx: ActionContext) {
    this.ctx = ctx;
    this.strategy = { ...ctx.edited }; // clone
    this.drawer().open();
  }

  isValidDuration(duration: string) {
    if (!duration) return false;
    const parts = duration.split(':');

    if (parts.length !== 3) return false;

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      const int = parseInt(part);
      if (Number.isNaN(int) || int < 0) return false;

      // is minute
      if (i == parts.length - 1 && !(0 <= int && int <= 60))
        return false;

      // is hour
      if (i == parts.length - 2 && !(0 <= int && int <= 60))
        return false;
    }
    return true;
  }

}


